export const GET_AWS_CREDENTIALS_SUCCESS = "GET_AWS_CREDENTIALS_SUCCESS";